import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=6c6be170&scoped=true&"
import script from "./Step5.vue?vue&type=script&lang=js&"
export * from "./Step5.vue?vue&type=script&lang=js&"
import style0 from "./Step5.vue?vue&type=style&index=0&id=6c6be170&prod&lang=scss&"
import style1 from "./Step5.vue?vue&type=style&index=1&id=6c6be170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6be170",
  null
  
)

export default component.exports